export default "__VITE_ASSET__BH5PiqyV__"